import * as Sentry from '@sentry/nextjs';
import type { SeverityLevel } from '@sentry/core';
import logger from '@utils/logger';

export const logToSentry = (level: SeverityLevel, message: string, details: string) => {
  switch (level) {
    case 'fatal':
    case 'error':
      logger.error(`${message}\n`, details);
      break;
    case 'warning':
      logger.warn(`${message}\n`, details);
      break;
    case 'log':
    case 'info':
      logger.info(`${message}\n`, details);
      break;
    case 'debug':
    default:
      logger.debug(`${message}\n`, details);
  }

  const customLog: Sentry.Event = {
    message,
    level,
    breadcrumbs: [
      {
        message: details,
        level,
      },
    ],
  };
  Sentry.captureEvent(customLog);
};

export const useSentryLogger = (): {
  logToSentry: (level: SeverityLevel, message: string, details: string) => void;
} => ({ logToSentry });
